import { render, staticRenderFns } from "./AddFinalContract.vue?vue&type=template&id=470dc026"
import script from "./AddFinalContract.vue?vue&type=script&lang=js"
export * from "./AddFinalContract.vue?vue&type=script&lang=js"
import style0 from "./AddFinalContract.vue?vue&type=style&index=0&id=470dc026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports